<template>
    <div>
        <section class="about_us section-padding">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="section-header">
                            <h3 class="text-center text-uppercase">
                                Terminos y Condiciones De Consignación De Vehículo Automotor
                            </h3>
                            <p>Version vigente desde 01/06/2021</p>
                            <p class="text-justify">
                                Este contrato describe los términos y condiciones generales para
                                la consignación de un vehículo automoir aplicables al uso de los
                                servicios ofrecidos por RED AUTOS S.A.S dentro del sitio
                                www.redautos.com. Cualquier persona que desee consignar un
                                vehículo y/o usar el sitio o los servicios podrá hacerlo
                                sujetándose a los Términos y Condiciones , junto con todas las
                                demás políticas y principios que rigen Redautos.com y que son
                                incorporados al presente por referencia.
                            </p>
                            <p class="text-justify">
                                <b>
                                    El Usuario debe leer, entender y aceptar todas las condiciones
                                    establecidas en los siguientes Términos y Condiciones y en las
                                    Políticas de Privacidad así como en los demás documentos
                                    incorporados a los mismos por referencia, previo a su
                                    inscripción como Usuario de Redautos.com.
                                </b>
                            </p>
                            <hr>
                            <p class="text-justify">
                                El presente contrato de consignación se celebrará entre
                                <b>RED AUTOS SAS</b>
                                empresa legalmente constituida y habilitada para comercializar
                                vehículos automotores usados, identificada con NIT No.
                                <b>900935122-8</b>
                                quien para efectos del presente contrato se llamará EL
                                CONSIGNATARIO;
                                <b>{{ nombre }} {{ apellido }}</b>
                                identificado con {{ tipo_doc }} No.
                                <b>{{ documento }}</b>
                                quien será EL CONSIGNANTE.
                            </p>
                            <p class="text-justify">
                                Domicilio del consignante {{ ubicacion }} su número de contacto es
                                {{ telefono }} y su correo: {{ correo }}. Las partes acuerdan conjuntamente
                                sobre las siguientes cláusulas para la consignación del vehículo
                                automotor de las siguientes características
                            </p>
                            <table class="table">
                                <tbody class="text-uppercase">
                                    <tr>
                                        <td><b>MARCA</b></td>
                                        <td>{{ marca }}</td>
                                        <td><b>LINEA</b></td>
                                        <td>{{ linea }}</td>
                                        <td><b>MODELO</b></td>
                                        <td>{{ modelo }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>COLOR</b></td>
                                        <td>{{ color }}</td>
                                        <td><b>KILOMETRAJE</b></td>
                                        <td>{{ numberWithDotsNotRounded(kilometraje) }}</td>
                                        <td><b>PLACA</b></td>
                                        <td>{{ placa }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="about_content">
                                <h5>
                                    Primera.-
                                    <span>Declaraciones del consignante:</span>
                                </h5>
                                <ol class="text-justify">
                                    <li>
                                        Declara ser el legítimo propietario del vehículo automotor.
                                    </li>
                                    <li>
                                        Declara tener la capacidad jurídica para obligarse y
                                        responder ante cualquier eventualidad que surja con el bien
                                        objeto del presente contrato.
                                    </li>
                                    <li>
                                        Declara que el vehículo está libre de multas, embargos,
                                        secuestro, gravámenes o cualquier otra limitación a la
                                        propiedad que afecten su libre comercialización. De lo
                                        contrario, autoriza a EL CONSIGNATARIO a liberar el carro de
                                        cualquier deuda o compromiso pendiente.
                                    </li>
                                    <li>
                                        Declara en cumplimiento a lo señalado al respecto en la
                                        Circular Externa No.029 de 2014 expedida por la
                                        Superintendencia Financiera de Colombia, en el Estatuto
                                        Orgánico del Sistema Financiero (Decreto 663 de 1993), el
                                        Decreto 2555 de 2010, Ley 190 de 1995, Ley 1474 De 2011
                                        “Estatuto Anticorrupción” y demás normas legales
                                        concordantes, que los recursos utilizados para la compra y
                                        la obtención del vehículo automotor no provienen de ninguna
                                        actividad ilícita contemplada en el Código Penal Colombiano
                                        o en cualquier norma que lo modifique o adicione.
                                    </li>
                                    <li>
                                        Declara que el estado del motor está en óptimas condiciones,
                                        que el chasis se encuentra original y que el vehículo objeto
                                        del presente contrato no presenta problemas legales como,
                                        regrabación de improntas, “gemelización”, y/o se encuentre
                                        en un proceso de extinción de dominio.
                                    </li>
                                </ol>
                                <h5>
                                    Segunda.-
                                    <span>Declaraciones del consignatario:</span>
                                </h5>
                                <ol class="text-justify">
                                    <li>
                                        Declara ser una sociedad inscrita en Cámara de Comercio el
                                        02 de febrero de 2016 bajo el No. 1298 del libro IX, lo cual
                                        certifica su constitución como consta en el documento
                                        privado del 27 de enero de 2016 de la ciudad de Cali, Valle
                                        del Cauca.
                                    </li>
                                    <li>
                                        Declara que su domicilio principal es la Calle 5 Norte No.
                                        14-47 Barrio San Juan Bosco.
                                    </li>
                                    <li>
                                        Declara que cuenta con la infraestructura, y los asesores y
                                        la capacidad necesaria para la comercialización y
                                        consignación de vehículos usados.
                                    </li>
                                </ol>
                                <h5>
                                    Tercera.-
                                    <span>
                                        Objeto:
                                    </span>
                                </h5>
                                <p class="text-justify">
                                    Se firmará entre las partes el presente contrato de
                                    consignación con el fin de que EL CONSIGNATARIO esté
                                    autorizado para:
                                </p>
                                <ul class="text-justify">
                                    <li>
                                        Utilizar la guía de Avaluauto.com como referencia del
                                        mercado para establecer el precio de venta.
                                    </li>
                                    <li>
                                        Tomar fotos y videos del vehículo, para ser publicadas tanto
                                        en portales como en redes sociales.
                                    </li>
                                    <li>
                                        Capturar y administrar los leads que llegan a través de los
                                        diferentes canales.
                                    </li>
                                    <li>
                                        Agendar las citas que se concreten para mostrar el vehículo.
                                    </li>
                                    <li>
                                        Exhibir y ofrecer el vehículo a terceros interesados.
                                    </li>
                                    <li>
                                        Realizar prueba de ruta.
                                    </li>
                                    <li>
                                        Llevar el carro a los centros de inspección.
                                    </li>
                                    <li>
                                        Administrar el proceso de venta, garantizando recaudo y
                                        traspaso.
                                    </li>
                                </ul>
                                <h5>
                                    Cuarta.-
                                    <span>Responsabilidad:</span>
                                </h5>
                                <p class="text-justify">
                                    EL CONSIGNATARIO se hace responsable por los daños o pérdidas
                                    parciales que sufra el vehículo usado objeto del presente
                                    contrato mientras se encuentre bajo su resguardo y depósito
                                    siempre y cuando EL CONSIGNANTE asuma los gastos
                                    administrativos que conlleva la consignación del vehículo en
                                    las instalaciones de RED AUTOS.
                                </p>
                                <p class="text-justify">
                                    Dichos gastos serán aceptados con la firma del presente
                                    contrato, asumiendo en su totalidad el precio acordado de
                                    CIENTO CINCUENTA MIL PESOS MCTE ($150.000.oo) IVA incluido.
                                </p>
                                <h5>
                                    Quinta.-
                                    <span>Precio:</span>
                                </h5>
                                <p class="text-justify">
                                    El precio acordado entre las partes será:
                                </p>
                                <ul>
                                    <li>PRECIO DE PUBLICACIÓN: ${{ numberWithDotsNotRounded(precio_publicacion) || 0 }}
                                    </li>
                                    <li>PRECIO MÍNIMO: ${{ numberWithDotsNotRounded(precio_sugerido) || 0 }}</li>
                                </ul>
                                <p class="text-justify">
                                    En caso de que el precio sea inferior al precio de venta, EL
                                    CONSIGNANTE deberá aprobarlo para así cerrar el negocio.
                                </p>
                                <p class="text-justify">
                                    En caso de que el precio sea superior al precio acordado de
                                    venta, EL CONSIGNATARIO podrá manejar un sobre precio que se
                                    destinará al administrador del negocio.
                                </p>
                                <h5>
                                    Sexta.-
                                    <span>Gastos Adicionales:</span>
                                </h5>
                                <p class="text-justify">
                                    Si por algún motivo el vehículo es rechazado en el peritaje,
                                    EL CONSIGNATE deberá asumir el costo del mismo. El rechazo del
                                    vehículo en el centro de inspección será causal suficiente
                                    para dar por terminado el contrato de consignación.
                                </p>
                                <p class="text-justify">
                                    Los vehículos que permanezcan en la vitrina deberán pagar una tarifa de $10.000
                                    pesos diarios, destinada a cubrir los gastos de parqueadero, lavado, transporte y
                                    seguro del vehículo. Si el vehículo permanece en la vitrina entre 20 y 30 días, se
                                    aplicará una tarifa fija de $200.000 pesos mensuales, correspondiente a los costos
                                    de administración, parqueadero y demás gastos operativos.
                                </p>
                                <h5>
                                    Séptima.-
                                    <span>Exclusividad en portales:</span>
                                </h5>
                                <p class="text-justify">
                                    Ya que EL CONSIGNANTE se encuentra contratando los servicios
                                    de EL CONSIGNATARIO, la publicación del vehículo en los
                                    portales la realizará únicamente éste último por el término de
                                    treinta (30) días. Cumplidos, EL CONSIGNANTE podrá publicarlo
                                    en las mismas condiciones, y el vehículo podrá figurar para
                                    ambos.
                                </p>
                                <h5>
                                    Octava.-
                                    <span>Documentos:</span>
                                </h5>
                                <p class="text-justify">
                                    Se requieren, para comercializar el bien objeto del presente
                                    contrato, los siguientes documentos:
                                </p>
                                <ul>
                                    <li>Tarjeta de propiedad</li>
                                    <li>Cédula del propietario</li>
                                </ul>
                                <p class="text-justify">
                                    Para la venta del bien, adicional a los anteriores, se deberán
                                    aportar los siguientes:
                                </p>
                                <ul>
                                    <li>Certificado de tradición</li>
                                    <li>Factura de venta inicial del vehículo</li>
                                    <li>Declaración de importación</li>
                                </ul>
                                <p class="text-justify">
                                    Si alguno de los documentos anteriores no está en poder del EL
                                    CONSIGNANTE, podrá ser obtenido directamente por EL
                                    CONSIGNATARIO, y dicho gasto será asumido por el nuevo
                                    propietario.
                                </p>
                                <h5>
                                    Novena.-
                                    <span>Recaudo y Garantía:</span>
                                </h5>
                                <p class="text-justify">
                                    EL CONSIGNANTE autoriza a EL CONSIGNATARIO que de efectuarse
                                    una venta por el bien objeto del presente contrato, el recaudo
                                    del dinero se realice según lo acordado para el caso en
                                    concreto.
                                </p>
                                <p class="text-justify">
                                    Como garantía, EL CONSIGNATARIO dispondrá del 20% del valor
                                    total del vehículo, asegurando el traspaso. Una vez legalizado
                                    el trámite, tendrá un periodo no mayor a tres (03) días para
                                    consignar el saldo restante al EL CONSIGNANTE.
                                </p>
                                <h5>
                                    Décima.-
                                    <span>Comisión:</span>
                                </h5>
                                <p class="text-justify">
                                    Las partes acuerdan conjuntamente que costo por la prestación
                                    del servicio de consignación consistirá en un tres (03) por
                                    ciento % más IVA del precio acordado para la venta del
                                    vehículo, el cual se descontará al finalizar el negocio.
                                </p>
                                <h5>
                                    Décima Primera.-
                                    <span>Gastos transaccionales:</span>
                                </h5>
                                <p class="text-justify">
                                    Los movimientos financieros generados por la realización del negocio al momento de
                                    la venta del vehículo, incluidos los costos asociados a dineros de terceros
                                    provenientes de la venta del vehículo, como el gravamen del 4x1000, serán asumidos
                                    por EL CONSIGNANTE.
                                </p>
                                <h5>
                                    Décima Segunda.-
                                    <span>Autorización tratamiento de datos personales</span>
                                </h5>
                                <p class="text-justify">
                                    Con la aceptación del presente contrato, se permite el
                                    tratamiento de datos personales para: i) proveer un buen
                                    servicio; ii) lograr una eficiente comunicación;) evaluar la
                                    calidad del servicio.
                                </p>
                                <br />
                                <br />
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value=""
                                        @click="disabled = !disabled" />
                                    <label class="form-check-label">
                                        EL CONSIGNANTE acepta y reconoce que los datos suministrados
                                        son ciertos, y que bajo ninguna circunstancia se ha omitido
                                        y/o adulterado alguna información suministrada.
                                    </label>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-md-6">
                                    <b-col md="12" class="text-center">
                                        <b-button block @click="enviarNotificacion" :disabled="disabled">
                                            Acepto
                                        </b-button>
                                    </b-col>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import mainHelper from 'helpers/main-helper';
export default {
    data() {
        return {
            disabled: true
        }
    },
    props: {
        id: {
            default: 0
        },
        nombre: {
            default: ''
        },
        apellido: {
            default: ''
        },
        tipo_doc: {
            default: ''
        },
        documento: {
            default: ''
        },
        marca: {
            default: ''
        },
        linea: {
            default: ''
        },
        modelo: {
            default: ''
        },
        color: {
            default: ''
        },
        kilometraje: {
            default: 0
        },
        placa: {
            default: ''
        },
        ubicacion: {
            default: ''
        },
        telefono: {
            default: 0
        },
        correo: {
            default: ''
        },
        precio_publicacion: {
            default: 0
        },
        precio_sugerido: {
            default: 0
        },
    },
    methods: {
        enviarNotificacion() {
            var data = {
                id_reporte: this.id
            };
            axios.post('/handler/consignacion/confirmacion_tyc', data).then((response) => {
                var parseRes = response.data;
                this.$swal.fire({
                    icon: 'success',
                    title: 'Aceptaste los terminos y condiciones',
                    text: '¡Se enviara una copia de este contrato a tu correo!',
                    confirmButtonColor: '#858796',
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.close();
                    }
                })
            });
        },
        numberWithDotsNotRounded(string) {
            return mainHelper.numberWithDotsNotRounded(string)
        },
    }
}
</script>

<style lang="scss" scoped></style>
